export default __webpack_public_path__ + "static/dont-be-boring-course@2x-4b4f24e21709e7a96f71437200bdc986.png";